<template>
  <div class="book-detail-page">
    <section class="bd-info">
      <img class="cover" :src="book_data.cover_img" alt />
      <div>
        <div class="base-info">
          <p class="bdi-title">{{book_data.book}}</p>
          <div class="teacher" v-if="!group_info.id">作者：{{book_data.author}}</div>
          <p class="stock">
            <font>库存：</font>
            <span>{{book_data.stock - book_data.sales_num}}</span>
          </p>
        </div>
        <div class="bdi-price">
          <template v-if="group_info.id">
            <p class="teachers">{{book_data.author}}</p>
          </template>
          <template v-else>
            <p class="now-price">
              <icon-price v-if="book_data.price" :priceType="2"></icon-price>
              <span v-if="book_data.price">{{book_data.price | toFixPrice}}</span>
              <span v-else>免费</span>
            </p>
            <p class="under-price" v-if="book_data.underlined_price">
              <icon-price :priceType="2" size="mini"></icon-price>
              <span>{{book_data.underlined_price | toFixPrice}}</span>
            </p>
          </template>
          <p class="ship-price">
            <font>运费：</font>
            <span v-if="book_data.ship_price">{{book_data.ship_price | toFixPrice}}元</span>
            <span v-else>免运费</span>
          </p>
        </div>
      </div>
    </section>
    <group-info v-if="group_info.id" :info="group_info" comType="book_detail"></group-info>
    <active
      v-if="book_data.price"
      :couponList="coupon.all"
      :detail="book_data"
      :group-info="group_info"
      @setCoupon="setCoupon"
    ></active>
    <group v-if="group_info.id" :list="group_list" :info="group_info"></group>
    <div class="header" id="nav-head">
      <header :class="{'fixed-sty': fix}">
        <div class="h-title">
          <p>
            <span :class="{'active':active=='tro'}" @click="scrollTo('tro')">图书介绍</span>
            <span :class="{'active':active=='com'}" @click="scrollTo('com')">图书评价</span>
          </p>
        </div>
      </header>
    </div>
    <div class="cd-tro" id="tro">
      <p class="cd-title">图书详情</p>
      <div class="cd-details" v-html="book_data.details"></div>
    </div>
    <div class="com-style" id="com">
      <p class="cd-title">图书评论</p>
      <commentItem></commentItem>
    </div>
    <template v-if="group_info.id">
      <p
        class="notice"
        v-if="group_info.stock - group_info.sales_num > 0"
      >拼团名额剩余{{group_info.stock - group_info.sales_num}}个，请尽快开团抢购哦</p>
      <p class="notice" v-else>拼团名额已售罄，可单独购买学习哦</p>
    </template>
    <footer-btn v-if="!group_info.id" title="立即购买" @submit="submit"></footer-btn>
    <footer-btn v-else>
      <div class="btns" slot="btn">
        <div class="left-btn" @click="submit">
          <p class="p1">
            <icon-price size="mini" :priceType="2"></icon-price>
            <span>{{group_info.price | toFixPrice}}</span>
          </p>
          <p>单独购买</p>
        </div>
        <div
          class="right-btn"
          @click="openSpell"
          :class="{'default-btn': group_info.stock - group_info.sales_num == 0 && !group_info.is_join_spell}"
        >
          <p class="p1">
            <icon-price size="mini" :priceType="2"></icon-price>
            <span v-if="group_info.head_price">{{group_info.head_price | toFixPrice}}</span>
            <span v-else>{{group_info.spell_price | toFixPrice}}</span>
          </p>
          <p>{{group_info.is_join_spell ? '查看我的团':'我要开团'}}</p>
        </div>
      </div>
    </footer-btn>
    <!-- <back-spell :config="{redirect:'Index',title: '返回首页'}" v-if="$route.query.share_source"></back-spell> -->
    <DistributeShopShare :distribute_item="distribute_item" :dis_type="1"></DistributeShopShare>
  </div>
</template>

<script>
import active from "@/components/book/Active.vue";
import commentItem from "@/components/CommentItem";
import group from "@/components/group/GroupList";
import groupInfo from "@/components/group/GroupInfo";
import DistributeShopShare from "@/components/distribute/ShopShare";
export default {
  name: "BookDetail",
  components: {
    active,
    commentItem,
    group,
    groupInfo,
    DistributeShopShare
  },
  data() {
    return {
      id: this.$route.query.id,
      book_data: {},
      coupon: [],
      group_info: {
        id: ""
      },
      group_list: [],
      fix: false,
      active: "",
      top: 0,
      distribute_item: null
    };
  },
  methods: {
    goBack() {
      if (this.$store.state.app) {
        this.$store.commit("BACK_NORMAL", 0);
      }
      this.$router.go(-1);
    },
    /**
     * 拼团信息
     *  */
    async getGroupInfo() {
      let group_info = await this.$http.get(
        `/api/app/spellGroupInfo/${this.id}/book`
      );
      if (!Array.isArray(group_info)) {
        let data = await this.$http.get(`/api/app/spellGroup/${group_info.id}`);
        data.list.forEach(item => {
          item.surpTime = item.end_time - Date.parse(new Date()) / 1000;
        });
        this.group_list = data.list;
        group_info.surp_time =
          group_info.end_time - Date.parse(new Date()) / 1000;
        this.group_info = group_info;
      }
    },
    async getBookDetail() {
      let book_data = await this.$http.get(`/api/app/book/detail/${this.id}`);
      this.distribute_item = book_data.distribute_item;
      this.book_data = book_data;
      this.coupon = book_data.coupon;
      // 图书详情分享
      this.$store.dispatch("setShare", {
        share_type: 2,
        route: this.$route,
        web_title: book_data.book,
        web_description: book_data.instruction,
        mobile_logo: book_data.cover_img
      });
    },
    setCoupon(index) {
      this.couponList[index].is_can_get = 0;
    },
    /**
     * 滑动导航
     *  */
    handleScroll() {
      this.top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let a_h = window.$("#tro").offset().top - 240;
      let r_h = window.$("#com").offset().top - 240;
      let n_h = window.$("#nav-head").offset().top;
      if (this.top > n_h) {
        this.fix = true;
      } else {
        this.fix = false;
      }
      if (this.top <= a_h) {
        this.active = "tro";
      } else if (this.top >= r_h) {
        this.active = "com";
      }
    },
    scrollTo(name) {
      this.active = name;
      let h = window.$(`#${name}`).offset().top - 240;
      window.$("html,body").animate({ scrollTop: h }, 500);
    },
    /**
     * 开团
     *  */
    async openSpell() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.group_info.is_join_spell) {
          // 查看我的团
          this.$router.push({
            name: "GroupDetail",
            query: {
              group_id: this.group_info.group_id
            }
          });
        } else {
          // 开团
          let flag = await this.$store.dispatch("CheckSpell", {
            spell_id: this.group_info.id
          });
          if (flag) {
            this.$router.push({
              name: "Purchase",
              query: {
                id: this.$route.query.id,
                type: 12,
                spell_id: this.group_info.id,
                group_id: 0
              }
            });
          }
        }
      }
    },
    submit() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.book_data.stock - this.book_data.sales_num <= 0) {
          this.$toast({
            message: "你来晚了哦,库存已经没有了~",
            duration: 1000
          });
        } else {
          this.$router.push({
            name: "Purchase",
            query: {
              id: this.id,
              type: 12
            }
          });
        }
      }
    }
  },
  async created() {
    if (this.$route.query.distribute_uid) {
      await this.$http.get(
        "/api/distribute/item/bind/" + this.$route.query.distribute_uid
      );
    }
    this.getBookDetail();
    this.getGroupInfo();
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.handleScroll);
    }, 300);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.book-detail-page {
  @extend %default-bg;
  padding-bottom: 150px;
  .bd-info {
    background: #fff;
    display: flex;
    padding: 54px 30px;
    .cover {
      width: 206px;
      height: 288px;
      box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.35);
      flex: none;
    }
    > div {
      margin-left: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .bdi-title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 48px;
      }
      .stock {
        padding-top: 25px;
        height: 40px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        font {
          color: rgba(140, 140, 140, 1);
        }
        span {
          color: #595959;
        }
      }
      .teacher {
        margin-top: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        line-height: 40px;
      }
      .bdi-price {
        display: flex;
        justify-content: space-between;
        /deep/ .price-ico {
          width: 16px;
          margin: 0 4px;
        }
        .teachers {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          height: 40px;
          line-height: 40px;
        }
        .now-price {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(238, 31, 31, 1);
        }
        .under-price {
          flex: 1;
          font-size: 24px;
          color: #979797;
          margin-top: 6px;
          margin-left: 6px;
          text-decoration: line-through;
        }
        .ship-price {
          height: 34px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          line-height: 34px;
        }
      }
    }
  }
  .header {
    height: 88px;
    line-height: 88px;
    margin-top: 20px;
    header {
      @extend %flex-center;
      height: 88px;
      width: 100%;
      box-sizing: border-box;
      z-index: 9;
      background: #fff;
      border-bottom: 1px solid #f0f2f5;
    }
    .fixed-sty {
      position: fixed;
      top: 0px;
    }
    .header_box {
      width: 100%;
      height: 100%;
    }
    .h-title {
      flex: 2;
      h3 {
        text-align: center;
        font-size: 36px;
        color: #595959;
      }
      p {
        display: flex;
        justify-content: center;
        span {
          width: 33.33%;
          text-align: center;
          font-size: 30px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
        }
        span.active {
          color: #4169ff;
          font-weight: 500;
          font-size: 30px;
        }
      }
    }
  }
  .com-style {
    margin-top: 30px;
    background: #fff;
    padding: 10px 20px;
  }
  .cd-title {
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    padding-top: 20px;
  }
  .cd-tro {
    background: #fff;
    padding: 10px 20px;
    .cd-details {
      font-size: 28px;
      padding: 30px 10px;
      line-height: 36px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      /deep/ p {
        width: 100%;
      }
      /deep/ img {
        width: 100% !important;
        height: auto !important;
        display: block;
        border: none;
      }
      /deep/ video {
        width: 100%;
      }
    }
  }
  /deep/ .btns {
    width: 688px;
    height: 74px;
    margin: 13px auto;
    border-radius: 37px;
    overflow: hidden;
    display: flex;
    .left-btn {
      width: 346px;
      height: 69px;
      padding-top: 5px;
      background: #ecf0ff;
      color: $theme_color;
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 32px;
        text-align: center;
      }
      .p1 {
        font-size: 26px;
      }
    }
    .right-btn {
      width: 346px;
      height: 69px;
      background: $theme_color;
      padding-top: 5px;
      color: #fff;
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 32px;
        text-align: center;
      }
      .p1 {
        font-size: 26px;
      }
    }
    .default-btn {
      color: #8c8c8c;
      background: rgba(244, 244, 244, 1);
    }
  }
  .notice {
    height: 54px;
    line-height: 54px;
    position: fixed;
    bottom: 100px;
    left: 0;
    right: 0;
    background: #f4f4f4;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
    text-align: center;
  }
}
</style>
